import { render, staticRenderFns } from "./Oportunidade.vue?vue&type=template&id=42da2935&scoped=true&lang=pug&"
import script from "./Oportunidade.vue?vue&type=script&lang=js&"
export * from "./Oportunidade.vue?vue&type=script&lang=js&"
import style0 from "./Oportunidade.styl?vue&type=style&index=0&id=42da2935&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da2935",
  null
  
)

export default component.exports